import UserMediaDocument from './UserMediaDocument';

export default UserMediaDocument;
